<script>
export default {
  name: "ContactsMap",
  props: {
    center: {
      type: Array,
      required: true,
    },
    zoom: {
      type: Number,
      required: true,
    },
    placemarks: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    //const DG = window.DG;

    window.DG.then(() => {
        /*
        const icon = window.DG.icon({
            iconUrl: '/images/placemark.svg',
            iconSize: [40, 40],
            iconAnchor: [20, 37],
        });
        */
        
        const map = window.DG.map(this.$refs.element, {
            center: this.center,
            zoom: this.zoom
        });

        this.placemarks.forEach((item) => {
          window.DG.marker(item.coord/*, {icon: icon}*/).addTo(map).bindPopup(item.description);
        });
    });
  }
};
</script>

<template>
  <div class="contacts-map" ref="element"></div>
</template>

<style lang="scss" scoped>
.contacts-map {
  height: 100%;
  border-radius: 15px;
}
</style>
